/**
 * Check if a request can be held based on when it was submitted (dateRequested)
 * A request can be held only if it was submitted 15 or more days ago
 * Cannot hold if submitted less than 15 days ago
 * Accepts dates in both MM/DD/YYYY and ISO (YYYY-MM-DD) formats
 */
export const canHoldRequest = (
  dateRequested: string,
  toTypeCd?: string
): boolean => {
  if (!dateRequested) return true

  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const requestDate = new Date(dateRequested)
  requestDate.setHours(0, 0, 0, 0)

  const timeDiff = requestDate.getTime() - today.getTime()

  const daysUntilRequest = Math.floor(
    timeDiff / (1000 * 60 * 60 * 24)
  )

  const minimumDaysRequired = toTypeCd === 'A' ? 1 : 15

  return daysUntilRequest >= minimumDaysRequired
}
/**
 * Get the earliest date from a list of table rows
 * Date format: MM/DD/YYYY
 */
export const getEarliestDate = (tableRows: Array<{ date?: string; [key: string]: any }>): string => {
  if (!tableRows || tableRows.length === 0) return ''
  
  // Find earliest date in MM/DD/YYYY format
  let earliestDate = tableRows[0]?.date || ''
  
  for (let i = 1; i < tableRows.length; i++) {
    const currentDate = tableRows[i]?.date || ''
    if (currentDate && earliestDate) {
      const [m1, d1, y1] = currentDate.split('/').map(Number)
      const [m2, d2, y2] = earliestDate.split('/').map(Number)
      
      const date1 = new Date(y1, m1 - 1, d1)
      const date2 = new Date(y2, m2 - 1, d2)
      
      if (date1 < date2) {
        earliestDate = currentDate
      }
    }
  }
  
  return earliestDate
}
